module.exports = __webpack_public_path__ + "static/img/CgoRC2RBBRmAWToZAATqZec3Qb8312.ace4017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2RBBRmAWToZAATqZec3Qb8312.jpg
// module id = o1gN
// module chunks = 73